var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"checkbox-toggle",style:(_vm.disabled?'cursor: not-allowed':''),attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }